<div id="loadingPage" class="vertical-mid">
  <div id="transformDiv" class="make-transform text-center"></div>
  <div class="content-v-align text-center m-t-5">
    <div class="loading-content" aria-live="polite" data-i18n="partnerApp_redirect_overlay_content">
      One moment please, redirecting you back to TPP.
    </div>
  </div>
</div>
